// src/components/BottomTabs.jsx
import { NavLink, useLocation } from 'react-router-dom';
import { Home, User, Tag } from 'lucide-react';
import { useNotifications } from "../contexts/NotificationsContext"

export default function BottomTabs() {
  const location = useLocation();
  const isVisitorPage = location.pathname === '/';
  const { unreadCount } = useNotifications();

  const baseClass =
    'flex flex-col items-center justify-center gap-1 flex-1 py-2 transition-colors';

  const linkClass = ({ isActive }) =>
    `${baseClass} ${isActive ? 'text-orange-500' : 'text-gray-400'}`;

  return (
    <nav
      className="
        w-full h-16 bg-white border-t
        flex
        z-50
      "
    >
      {/* Accueil */}
      {!isVisitorPage && (
        <NavLink to="/user" className={linkClass}>
          <Home size={22} />
          <span className="text-xs">Accueil</span>
        </NavLink>
      )}

      {isVisitorPage && (
        <NavLink to="/" className={linkClass}>
          <Home size={22} />
          <span className="text-xs">Accueil</span>
        </NavLink>
      )}

      {/* Mes Produits */}
      <NavLink to="/posts" className={linkClass}>
        <Tag size={22} />
        <span className="text-xs">Mes Produits</span>
      </NavLink>

      {/* Compte avec badge de notifications */}
      <NavLink to="/account" className={linkClass}>
        {({ isActive }) => (
          <>
            <div className="relative">
              <User size={22} />
              {unreadCount > 0 && (
                <span 
                  className="
                    absolute -top-1 -right-2
                    bg-red-500 text-white 
                    text-[10px] font-bold 
                    rounded-full 
                    min-w-[18px] h-[18px] 
                    flex items-center justify-center 
                    px-1
                    shadow-sm
                  "
                >
                  {unreadCount > 99 ? '99+' : unreadCount}
                </span>
              )}
            </div>
            <span className={`text-xs ${isActive ? 'text-orange-500' : 'text-gray-400'}`}>
              Compte
            </span>
          </>
        )}
      </NavLink>
    </nav>
  );
}